var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"base-button-landing",class:{ 'white-button': _vm.styleButton === 'white' },attrs:{"disabled":_vm.disabled}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }